import { Link } from "@/components/common/Link";
export default function InvitoAllAzione() {
  return <section id="invito-allazione" className="bg-primary text-primary-foreground py-24 px-6 md:px-12 flex flex-col items-center justify-center text-center">
      <div className="max-w-4xl mx-auto flex flex-col items-center gap-10">
        <h2 className="font-serif italic text-3xl md:text-5xl lg:text-6xl leading-tight md:leading-tight lg:leading-tight font-medium tracking-wide">
          IL TUO VOTO È IMPORTANTE.
          <br className="hidden md:block" />
          Insieme, continuiamo a far crescere Albano!
        </h2>
        
        <Link to="/HowToVotePage" className="inline-flex items-center justify-center bg-secondary text-secondary-foreground rounded-full px-10 py-5 text-lg font-bold shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1 hover:bg-secondary/90">
          Scopri Come Votare
        </Link>
      </div>
    </section>;
}